import React, { useEffect, useRef, useState } from 'react';
import TextAnimate from './TextAnimate';
import '../styles/SkillsPattern.css'
const FirstPattern = ({trigger})=>{
    const [isTriggered,setIsTrigerred] = useState(false)
    const FirstStageClass = isTriggered ? 'first-part' : 'initial'
    const SecondStageClass = isTriggered ? 'second-part' : 'initial'
    const second_part_ref = useRef(null)
    //TRIGGER THE ANIMATION WHEN SCROLLING , NOTE: THE ANIMATION SHOULD BE TRIGGERED JUST ONCE PER STAGE
useEffect(()=>{
    if(second_part_ref.current){
        
        console.log(second_part_ref.current)
    }
    
})
    useEffect(()=>{

 if(trigger){
    setIsTrigerred(true)
    
 }
})

    return(
    <>
    
    <svg className={FirstStageClass}  width="199" height="991" viewBox="0 0 199 991" preserveAspectRatio='xMidYMax meet'  fill="none" xmlns="http://www.w3.org/2000/svg">
        
       
        
        <path  d="M102.499 0.776367L98.6772 984.769" stroke="#0066FF"/>
        <rect x="99" width="8" height="8" transform="rotate(45 100 5)" fill="#0066FF" y="0"/>
        <path  d="M99.5368 790.349L78.667 829.268L78.1368 965.767L64.2488 985.213L9 984.999" stroke="#0066FF"/>
        <path id='second-part' d="M99.4346 789.77L120.001 828.851L119.471 965.35L133.207 984.903L188.456 985.118" stroke="#0066FF"/>
        
        <circle  cx="193.019" cy="985.019" r="4.5" transform="rotate(0.222555 193.019 985.019)" stroke="#0066FF"/>
        <circle   cx="5.01938" cy="985.019" r="4.5" transform="rotate(0.222555 5.01938 985.019)" stroke="#0066FF"/>
        
        </svg>
        
        <TextAnimate direction="toTop">SKILLS</TextAnimate>
        <svg className={SecondStageClass} ref={second_part_ref}  width="199" height="217" viewBox="0 0 199 217" fill="none" xmlns="http://www.w3.org/2000/svg">
        
        <path  d="M99.7846 1L99 202.998" stroke="#0066FF"/>
        <path  d="M9 7H64.7407L79 27L78.3518 162.5L54.0463 195" stroke="#0066FF"/>

        <circle  cx="194" cy="7" r="4.5" stroke="#0066FF"/>
        <circle  cx="5" cy="7" r="4.5" stroke="#0066FF"/>
        <path  d="M190 7H134.259L120 27L120.648 162.5L144.954 195" stroke="#0066FF"/>

        <circle cx="148" cy="199" r="4.5" stroke="#0066FF"/>
        <circle  cx="52" cy="199" r="4.5" stroke="#0066FF"/>

        <rect x="99.0715" y="202.707" width="9" height="9" transform="rotate(45.0039 99.0715 202.707)" stroke="#0066FF"/>
        
    </svg>
</>
)
}
export default FirstPattern;